module.exports = __webpack_public_path__ + "static/media/MORRALLA.edb25b98.svg";